import { render, staticRenderFns } from "./InteractionsCard.vue?vue&type=template&id=3e8bfdf0&scoped=true&"
import script from "./InteractionsCard.vue?vue&type=script&lang=ts&"
export * from "./InteractionsCard.vue?vue&type=script&lang=ts&"
import style0 from "./InteractionsCard.vue?vue&type=style&index=0&id=3e8bfdf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8bfdf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
